import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { useStore } from '@feathr/extender/state';
import { useDocumentTitle } from '@feathr/hooks';

interface IUsePageTitleProps {
  pageTitle?: string;
  title?: ReactNode;
}

function usePageTitle({ pageTitle, title }: IUsePageTitleProps): void {
  const { eventId } = useParams<{ eventId: string }>();
  const { Events } = useStore();

  const titleSuffix = eventId ? Events.get(eventId)?.name : 'Feathr';
  const titleString = pageTitle ? pageTitle : title && typeof title === 'string' ? title : '';

  useDocumentTitle(titleString ? `${titleString} | ${titleSuffix}` : titleSuffix);
}

export default usePageTitle;
